import { render, staticRenderFns } from "./ModuleVideo.vue?vue&type=template&id=138ccc2e&scoped=true&"
import script from "./ModuleVideo.vue?vue&type=script&lang=js&"
export * from "./ModuleVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModuleVideo.vue?vue&type=style&index=0&id=138ccc2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ccc2e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoPlayer: require('/vercel/path0/components/VideoPlayer.vue').default})
